import React, { memo, useCallback, useContext, useState } from 'react'

import Placeholder from 'Pods/ThreeDStudio/Shared/Placeholder/Placeholder'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import assistPreview from 'images/three_d_studio/assist_tab/assist_preview.webp'

import AssistForm from './Components/AssistForm/AssistForm'
import AssistPosted from './Components/AssistPosted/AssistPosted'
import { isProjectPosted, markProjectPosted } from './Utils/postedProjectStorage'

function AssistTab() {
  const { designerAssistEnabled } = useContext(ThreeDStudioPageContext)
  const modelId = useThreeDStudioStore(state => state.ui?.openedModel?.id)
  const [submittedId, setSubmittedId] = useState(null)

  const handleSuccess = useCallback(() => {
    markProjectPosted(modelId)
    setSubmittedId(modelId)
  }, [modelId])

  if (!designerAssistEnabled) {
    return (
      <Placeholder
        title="Request for Designer Assistance"
        description="Get help from a real designer whenever you need it"
      >
        <div className="assist-tab__preview" aria-hidden="true">
          <img
            alt=""
            className="assist-tab__preview-image"
            src={assistPreview}
            height={234}
            width={296}
          />
        </div>
      </Placeholder>
    )
  }

  const isPosted = modelId != null && (submittedId === modelId || isProjectPosted(modelId))

  if (isPosted) {
    return <AssistPosted />
  }

  return <AssistForm onSuccess={handleSuccess} />
}

export default memo(AssistTab)
